import { render, staticRenderFns } from "./MainContentHeader.vue?vue&type=template&id=4599ebcf&scoped=true"
import script from "./MainContentHeader.vue?vue&type=script&lang=js"
export * from "./MainContentHeader.vue?vue&type=script&lang=js"
import style0 from "./MainContentHeader.vue?vue&type=style&index=0&id=4599ebcf&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4599ebcf",
  null
  
)

export default component.exports